exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// F:/Projects/anoki/src/app/pages/profile/profile.component.scss
// module id = ../../../../../src/app/pages/profile/profile.component.scss
// module chunks = main